const pluginName = 'multiFactor';
const organizationName = 'raceRoster';
const pluginNamespace = `${organizationName}.${pluginName}`;
const defaults = {
  i18n: {
    multiFactorApp: 'Please enter your two-factor authentication code',
    multiFactorPhone: 'Please enter the verification code sent to your phone',
    voiceCallSent: 'We are calling you with your code.',
  },
  routes: {
    sendCode: '/resend-phone-two-factor',
    sendVoiceCode: '/send-phone-two-factor-call',
  },
  callbacks: {
    error: () => {},
    success: () => {},
  },
};
const classes = {
  hidden: 'd-none',
  disabled: 'disabled',
};
const selectors = {
  labelText: '[data-js-authentication-multi-factor-label-text]',
  code: '[data-js-authentication-multi-factor-code]',
  method: '[data-js-authentication-multi-factor-method]',
  resend: '[data-js-authentication-multi-factor-resend]',
  call: '[data-js-authentication-multi-factor-call]',
  callConnector: '[data-js-authentication-multi-factor-call-connector]',
  switchToPhone: '[data-js-authentication-multi-factor-switch-to-phone]',
  switchToPhoneButton: '[data-js-authentication-multi-factor-switch-to-phone-button]',
  switchToApp: '[data-js-authentication-multi-factor-switch-to-app]',
  switchToAppButton: '[data-js-authentication-multi-factor-switch-to-app-button]',
  email: '[data-js-authentication-email]',
  password: '[data-js-authentication-password]',
  token: '[data-js-authentication-token]',
};

/**
 * Get a nice little package of elements
 * @param $element
 * @returns {Object}
 */
const getElements = ($element) => {
  const $form = $element.closest('form');

  return {
    $container: $element,
    $labelText: $element.find(selectors.labelText),
    $code: $element.find(selectors.code),
    $method: $element.find(selectors.method),
    $resend: $element.find(selectors.resend),
    $call: $element.find(selectors.call),
    $callConnector: $element.find(selectors.callConnector),
    $switchToPhone: $element.find(selectors.switchToPhone),
    $switchToPhoneButton: $element.find(selectors.switchToPhoneButton),
    $switchToApp: $element.find(selectors.switchToApp),
    $switchToAppButton: $element.find(selectors.switchToAppButton),
    $form,
    $email: $form.find(selectors.email),
    $password: $form.find(selectors.password),
    $token: $form.find(selectors.token),
  };
};

/**
 * Returns the plugin instance data for the element.
 * @param {jQuery} $element The plugin instance element.
 */
const getData = ($element) => $element.data(pluginName);

/**
 * Calls the provided custom callback and triggers the provided custom plugin event (if they exist)
 * @param data
 * @param hookName
 * @param parameters
 */
const triggerHook = (data, hookName, ...parameters) => {
  data.elements.$container
    .trigger(`${pluginNamespace}.${hookName}`, [data.elements.$element, data, ...parameters]);
  data.settings.callbacks[hookName]
    .call(data.elements.$element, data.elements.$element, data, ...parameters);
};

/**
 * Sends a new multi factor code to the user's phone
 * @param data
 */
const sendcode = (data) => {
  $.ajax({
    url: data.settings.routes.sendCode,
    method: 'post',
    data: {
      email: data.elements.$email.val(),
      password: data.elements.$password.val(),
      token: data.elements.$token.val(),
    },
  })
    .fail((response) => {
      triggerHook(data, 'error', response.responseText);
    });
};

/**
 * Requests a voice call containing a new multi factor code.
 * @param data
 */
const sendVoiceCode = (data) => {
  $.ajax({
    url: data.settings.routes.sendVoiceCode,
    method: 'post',
    data: {
      email: data.elements.$email.val(),
      password: data.elements.$password.val(),
      token: data.elements.$token.val(),
    },
  })
    .done(() => {
      triggerHook(data, 'success', data.settings.i18n.voiceCallSent);
    })
    .fail((response) => {
      triggerHook(data, 'error', response.responseText);
    });
};

/**
 * Switch between app and phone for multi factor
 * @param data
 * @param method
 * @param hasAlternative
 * @param sendCode
 */
const switchmethod = (data, method, hasAlternative, sendCode = false) => {
  data.elements.$method.val(method);

  switch (method) {
    case 'phone':
      if (sendCode) {
        sendcode(data);
      }

      data.elements.$labelText.text(data.settings.i18n.multiFactorPhone);
      data.elements.$resend.removeClass(classes.hidden);
      data.elements.$call.toggleClass(classes.hidden, !data.allowVoiceCall);
      data.elements.$callConnector.toggleClass(classes.hidden, !data.allowVoiceCall);
      data.elements.$switchToPhone.addClass(classes.hidden);

      if (hasAlternative) {
        data.elements.$switchToApp.removeClass(classes.hidden);
      } else {
        data.elements.$switchToApp.addClass(classes.hidden);
      }
      break;

    case 'app':
      data.elements.$labelText.text(data.settings.i18n.multiFactorApp);
      data.elements.$resend.addClass(classes.hidden);
      data.elements.$call.addClass(classes.hidden);
      data.elements.$callConnector.addClass(classes.hidden);
      data.elements.$switchToApp.addClass(classes.hidden);

      if (hasAlternative) {
        data.elements.$switchToPhone.removeClass(classes.hidden);
      } else {
        data.elements.$switchToPhone.addClass(classes.hidden);
      }
      break;

    default:
    // nothing
  }

  data.elements.$code.trigger('focus');
};

/**
 * Switch to multi factor mode
 * @param data
 * @param multiFactorData
 */
const enable = (data, multiFactorData) => {
  data.elements.$container.removeClass(classes.hidden);
  data.allowVoiceCall = multiFactorData.allow_voice_call === true;

  data.elements.$method.prop('disabled', false);

  data.elements.$code
    .prop('required', true)
    .prop('disabled', false)
    .trigger('focus');

  switchmethod(data, multiFactorData.default_method, multiFactorData.has_alternative);
};

/**
 * Switch away from multi factor mode
 * @param data
 */
const disable = (data) => {
  data.elements.$container.addClass(classes.hidden);

  data.elements.$method
    .val('')
    .prop('disabled', true);

  data.elements.$code
    .val('')
    .prop('required', false)
    .prop('disabled', true);
};

const methods = {
  enable,
  disable,
};

/**
 * Fires up
 * @param {HTMLElement} element Current element.
 * @param options
 */
const initialize = (element, options) => {
  const $element = $(element);

  if (getData($element)) {
    return;
  }

  const settings = $.extend(true, {}, $.fn[pluginName].defaults, options);
  const elements = getElements($element);
  const data = {
    settings,
    elements,
  };

  data.elements.$resend.on('click', () => sendcode(data));
  data.elements.$call.on('click', () => sendVoiceCode(data));
  data.elements.$switchToApp.on('click', () => switchmethod(data, 'app', true));
  data.elements.$switchToPhone.on('click', () => switchmethod(data, 'phone', true, true));

  data.elements.$container.data(pluginName, data);
};

/**
 * Calls the provided plugin method, passing in the provided parameters if they exist
 * @param element
 * @param method
 * @param parameters
 */
const callPluginMethod = (element, method, ...parameters) => {
  const $element = $(element);
  const data = $element.data(pluginName);

  if (!data) {
    return;
  }

  methods[method](data, ...parameters);
};

/**
 * The plugin for jQuery
 * @param {string|object} methodOrOptions The method as a string or options as an object
 */
const plugin = function Plugin(methodOrOptions, ...methodParameters) {
  if (methods[methodOrOptions]) {
    return this
      .each((index, element) => callPluginMethod(element, methodOrOptions, ...methodParameters));
  }

  if (methodOrOptions === Object(methodOrOptions) || !methodOrOptions) {
    return this.each((index, element) => initialize(element, methodOrOptions));
  }

  return $.error(`Method ${methodOrOptions} does not exist in ${pluginName}`);
};

plugin.defaults = defaults;

$(() => {
  if (plugin in $.fn) {
    return;
  }

  $.extend($.fn, {
    [pluginName]: plugin,
  });
});

$(() => {
  if (pluginName in $.fn) {
    return;
  }

  $.extend($.fn, {
    [pluginName]: plugin,
  });
});
